import { Flex, Text } from "rebass";
import { FacebookProvider, EmbeddedVideo } from "react-facebook";
import styled from "styled-components";
import * as moment from "moment";
import { LazyImage } from "./lazy-image";

const DetailEmbed = ({ className, fbUrl, scheduled_date }) => {
  const scheduledDateFormatted = moment(scheduled_date);

  // True if scheduled_date is defined AND greater than current date
  // False otherwise
  const isUpcoming = scheduledDateFormatted > moment();

  let dateString;
  if (isUpcoming) {
    dateString = scheduledDateFormatted.format("MMMM D [at] h:mm A");
  }

  // TODO: Replace with actual placeholder image/copy
  const placeholderImage = "../static/images/bg-gradient.jpg";
  const placeholderText =
    "Refresh this page at the scheduled time to watch the video.";

  return (
    <RatioWrapper
      fontSize={2}
      fontFamily="medium"
      color="black"
      className={className}
    >
      {isUpcoming ? (
        <Placeholder
          px={3}
          flexDirection="column"
          justifyContent="center"
          alignItems="center"
          color="white"
        >
          <PlaceholderImage src={placeholderImage} />
          <Text fontSize={[3, 4, 4, 5]}>{dateString}</Text>
          <Text mt={[3, 3, 3, 4]} fontSize={[1, 2, 2, 3]} textAlign="center">
            {placeholderText}
          </Text>
        </Placeholder>
      ) : (
        <FacebookProvider appId="2245044125555496">
          <EmbeddedVideo href={fbUrl} width="500" />
        </FacebookProvider>
      )}
    </RatioWrapper>
  );
};

const RatioWrapper = styled(Text)`
  position: relative;
  width: 100%;
  padding-bottom: 56.25%;
  height: 0;

  &::after {
    content: "loading...";
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    z-index: 1;
  }

  & .fb_iframe_widget {
    position: absolute;
    width: 100%;
    height: 100%;
    z-index: 2;

    > span,
    iframe {
      height: 100% !important;
      width: 100% !important;
    }
  }
`;

const Placeholder = styled(Flex)`
  position: absolute;
  width: 100%;
  height: 100%;
  z-index: 2;

  > * {
    z-index: 1;
  }
`;

const PlaceholderImage = styled(LazyImage)`
  position: absolute;
  height: 100%;
  width: 100%;
`;

export { DetailEmbed };
